<script>
import Aws from '@/services/Aws';
import { required} from "vuelidate/lib/validators";
import validationMessages from '@/components/validations'


export default {
  components:{
    validationMessages
  },
  props: ['launchTemplateName', 'inServiceInstances', 'launchTemplateId'],
  data() {
    return {
      csrf_token: localStorage.getItem('csrf_token'),
      submitted: false,
      showModal: false,
      tryingToEdit: false,
      showLoader:false,
      DBInstanceIdentifier: '',
      imageName: '',
      description: '',
    };
  },
  validations: {
    DBInstanceIdentifier: { required },
    imageName: { required },
  },
  methods: {

    async addNewTemplateVersion(){
      this.tryingToEdit = true;
      this.submitted = true;
      this.$v.$touch();

      if (this.$v.$invalid) {
        this.tryingToEdit = false;
        return;
      } else {
        try {
          await Aws.addNewTemplateVersion({
            DBInstanceIdentifier: this.DBInstanceIdentifier,
            imageName: this.imageName,
            launchTemplateId: this.launchTemplateId,
            launchTemplateName: this.launchTemplateName,
            description: this.description,
            csrf_token: this.csrf_token
          }).then((response) => {
            this.successmsg("New Template Version cron is scheduled to execute");
            this.closeModal();
          }).catch(error => {
            this.error = error.response.data.error ? error.response.data.error : "";
            this.failedmsg(this.error);
          }).finally(() => {
            this.refreshData();
            this.tryingToEdit = false
          });

        } catch (error) {
          this.error = error.response.data.error ? error.response.data.error : "";
          this.failedmsg(this.error)
        }
      }

      this.tryingToEdit = false
    },

    refreshData() {
      this.$emit('onRefresh')
    },

    closeModal() {
      this.showModal = false
    },

    resetProps() {
      this.tryingToEdit = false
      this.submitted = false
      this.DBInstanceIdentifier = ''
    },

    initialData(){

      let name = this.launchTemplateName.trim()

      // Extract "API-<version>(-extra)?" but stop before "-LaunchTemplate"
      let match = name.match(/^(api-[0-9]+(?:\.[0-9]+){0,2}(?:-[^-]+)?)(?=-LaunchTemplate)/i)

      // Default to whole name if no match
      let baseName = match ? match[1] : name

      // Format date as YYYYMMDD
      const today = new Date()
      const formattedDate = today.getFullYear().toString()
              + String(today.getMonth() + 1).padStart(2, '0')
              + String(today.getDate()).padStart(2, '0')

      this.imageName = `${baseName}-${formattedDate}`

      this.description = this.imageName
    }

  }
};
</script>

<template>
  <b-modal @shown="initialData" @hidden="resetProps" v-model="showModal" id="addNewTemplateVersion" title="Add New Template Version" title-class="font-18" centered>
    <form @submit.prevent="addNewTemplateVersion">
      <div class="row">

        <div class="col-12">
          <p class="font-size-16 mb-2"><span class="text-strong">Launch Template Name:</span> {{launchTemplateName}}</p>
          <p class="font-size-16 mb-2"><span class="text-strong">Launch Template ID:</span> {{launchTemplateId}}</p>
        </div>

        <div class="col-sm-12 col-md-12">
          <label class="control-label form-label">Choose Instance</label>
          <b-form-select
              class="form-control"
              aria-describedby="dbinstances"
              v-model="DBInstanceIdentifier"
              :class="{
                  'is-invalid': submitted && $v.DBInstanceIdentifier.$error,
                }"
          >
            <option v-for="instance in inServiceInstances" :key="instance.InstanceId" :value="instance.InstanceId">
              {{ instance.InstanceId }} {{ instance.InstanceName }}
            </option>
          </b-form-select>
          <validationMessages v-if="submitted" :fieldName="'Instance'" :validationName="$v.DBInstanceIdentifier"></validationMessages>
        </div>

        <div class="col-sm-12 col-md-12">
          <div class="form-group">
            <label for="imageName">Image Name:</label>
            <input type="text" id="imageName"
                   class="form-control"
                   v-model="imageName"
                   :class="{
                      'is-invalid': submitted && $v.imageName.$error,
                    }"
            />
            <validationMessages v-if="submitted" :fieldName="'Image Name'" :validationName="$v.imageName"></validationMessages>
          </div>
        </div>

        <div class="col-sm-12 col-md-12">
          <div class="form-group">
            <label for="description">Description:</label>
            <input type="text" id="description" class="form-control" v-model="description" />
          </div>
        </div>

      </div>

    </form>
    <template v-slot:modal-footer>
      <b-button variant="light" @click="closeModal">Close</b-button>
      <b-button variant="primary" @click="addNewTemplateVersion" :disabled="tryingToEdit">
        <b-spinner v-show="tryingToEdit" small></b-spinner>
        Create</b-button>
    </template>
  </b-modal>
</template>